
import React from "react";
import { Button } from "@/components/ui/button";
import { useTranslation } from 'react-i18next';

interface ChippingScoreButtonsProps {
  onScoreChange: (score: number) => void;
}

const ChippingScoreButtons: React.FC<ChippingScoreButtonsProps> = ({
  onScoreChange,
}) => {
  const { t } = useTranslation('training');
  
  return (
    <>
      <Button 
        onClick={() => onScoreChange(6)} 
        className="h-14 text-base font-medium bg-green-600 hover:bg-green-700 text-white border-0 w-full mb-2"
      >
        {t('level3.scoring.chipping.ballIn')}
      </Button>
      <Button 
        onClick={() => onScoreChange(4)} 
        className="h-14 text-base font-medium bg-green-500 hover:bg-green-600 text-white border-0 w-full mb-2"
      >
        {t('level3.scoring.chipping.safeZone')}
      </Button>
      <Button 
        onClick={() => onScoreChange(3)} 
        className="h-14 text-base font-medium bg-green-400 hover:bg-green-500 text-white border-0 w-full mb-2"
      >
        {t('level3.scoring.chipping.ballAt1m')}
      </Button>
      <Button 
        onClick={() => onScoreChange(2)} 
        className="h-14 text-base font-medium bg-yellow-500 hover:bg-yellow-600 text-white border-0 w-full mb-2"
      >
        {t('level3.scoring.chipping.ballAt2m')}
      </Button>
      <Button 
        onClick={() => onScoreChange(1)} 
        className="h-14 text-base font-medium bg-yellow-600 hover:bg-yellow-700 text-white border-0 w-full mb-2"
      >
        {t('level3.scoring.chipping.ballAt3m')}
      </Button>
      <Button 
        onClick={() => onScoreChange(0)} 
        className="h-14 text-base font-medium bg-red-500 hover:bg-red-600 text-white border-0 w-full mb-2"
      >
        {t('level3.scoring.chipping.ballOutside')}
      </Button>
    </>
  );
};

export default ChippingScoreButtons;
